module.exports = __webpack_public_path__ + "static/media/_x32_16-microsoft.9c62e7ac.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/_x32_16-microsoft.svg
// module id = 328
// module chunks = 6 7